module.exports = __webpack_public_path__ + "img/dummy-passport-photo-1.f872d864.png";